import { render, staticRenderFns } from "./institutes.vue?vue&type=template&id=5848563c&scoped=true&"
import script from "./institutes.vue?vue&type=script&lang=js&"
export * from "./institutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5848563c",
  null
  
)

export default component.exports